const errorCode = {
  FILE_TOO_BIG: 'FILE_TOO_BIG',
  FILE_IS_BIG: 'FILE_IS_BIG',
  INVALID_FILE_TYPE: 'INVALID_FILE_TYPE',
  RESPONSE_ERROR: 'RESPONSE_ERROR',
  MAX_FILES_EXCEEDED: 'MAX_FILES_EXCEEDED',
  ONLY_ONE_FILE: 'ONLY_ONE_FILE',
};

const errorMessage = {
  [errorCode.FILE_TOO_BIG]: 'Your video ({{ fileSize }}MB) has exceeded the upload limit of {{ maxFileSize }}MB.',
  [errorCode.FILE_IS_BIG]: 'Your video ({{ fileSize }}MB) is larger than {{ maxFileSize }}MB.',
  [errorCode.INVALID_FILE_TYPE]: 'You can\'t upload file of this type. The supported file types are: {{ fileTypes }}',
  [errorCode.RESPONSE_ERROR]: 'Server responded with {{ statusCode }} code.',
  [errorCode.MAX_FILES_EXCEEDED]: 'You can not upload any more files.',
  [errorCode.ONLY_ONE_FILE]: 'You can only upload 1 video file per submission. Please cancel or remove the existing video.',
};

const delimeter = ' ';
const FILL_REGEX = /\{\{ [a-zA-Z]* \}\}/;

const fillErrorWithArguments = function fillErrorWithArguments(errorString, ...args) {
  let message = errorString;
  args.forEach((replacer) => {
    message = message.replace(FILL_REGEX, replacer);
  });
  return message;
};

export default {
  code: errorCode,
  fill: fillErrorWithArguments,
  make(code, ...args) {
    return code + delimeter + fillErrorWithArguments(errorMessage[code], ...args);
  },
  break(errorString) {
    const errorToken = errorString.split(' ');
    return {
      code: errorToken[0],
      message: errorToken.slice(1).join(delimeter),
    };
  },
};



// WEBPACK FOOTER //
// ./src/components/Submission/steps/VideoUpload/error.js